<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      transition="dialog-bottom-transition"
      max-width="1000"
      v-if="serverData"
    >
      <!--begin::Modal dialog-->
      <div class="bg-white poppins">
        <!--begin::Modal header-->
        <div class="modal-header py-4 align-center">
          <h4 class="mb-0 font-weight-bolder">{{ headerText }}</h4>
          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-light-info"
            @click="toggleModal"
          >
            <span class="svg-icon">
              <v-icon size="22">mdi-close</v-icon>
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div
          class="modal-body d-flex flex-column max-h-700px scroll-y mx-5 py-7"
        >
          <form class="row ma-0">
            <div class="col-12 col-sm-6 h-75px">
              <v-autocomplete
                v-model="formData.command_id"
                label="Command"
                :items="serverData.commands"
                item-text="text"
                item-value="index"
                dense
                clearable
                outlined
                :error-messages="command_idErrors"
                @blur="$v.formData.command_id.$touch()"
              />
            </div>

            <div class="col-12 col-sm-6 h-75px">
              <v-text-field
                v-model.number="formData.priority"
                label="Priority"
                type="number"
                dense
                outlined
                clearable
                :error-messages="priorityErrors"
                @blur="$v.formData.priority.$touch()"
                @change="() => validateMinValue('priority', 0)"
              />
            </div>

            <div class="col-12 col-sm-6 h-75px">
              <v-text-field
                v-model="formData.cron_expression"
                label="Cron expression"
                dense
                outlined
                clearable
                :error-messages="cron_expressionErrors"
                @blur="$v.formData.cron_expression.$touch()"
              />
            </div>

            <div class="col-12 col-sm-6 h-75px">
              <v-autocomplete
                v-model="formData.status"
                label="Status"
                :items="[
                  { index: 0, text: 'Disabled' },
                  { index: 1, text: 'Enabled' },
                ]"
                item-text="text"
                item-value="index"
                dense
                clearable
                outlined
              />
            </div>

            <div class="col-12 h-75px">
              <v-text-field
                v-model="formData.description"
                label="Description"
                dense
                outlined
                clearable
              />
            </div>
          </form>

          <!--begin::Actions-->
          <div class="mb-4 h-75px d-flex flex-grow-1 align-end justify-center">
            <button
              type="reset"
              class="btn btn-light mr-3 px-5 py-3 ls1"
              @click="resetFormData"
            >
              Clear
            </button>
            <button
              type="submit"
              class="btn btn-info px-5 py-3 ls1"
              @click="submitForm"
            >
              {{ submitButtonText }}
            </button>
          </div>
          <!--end::Actions-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal dialog-->
    </v-dialog>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import swalEdited from "@/core/services/AlertServices/SwalEdited";
import swalAdded from "@/core/services/AlertServices/SwalAdded";
import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";
export default {
  name: "ActionsDialog",
  props: ["refresher", "pageLoader"],
  mixins: [validationMixin, fieldValueValidation],
  components: {},
  validations: {
    formData: {
      command_id: { required },
      cron_expression: { required },
      priority: { required },
    },
  },
  data: () => ({
    dialog: false,
    serverData: null,
    menu: false,
    formData: {
      command_id: null,
      priority: null,
      cron_expression: null,
      status: null,
      description: null,
    },
  }),
  methods: {
    toggleModal() {
      if (this.dialog) {
        this.resetFormData();
        this.dialog = false;
        this.serverData = null;
      } else {
        this.loadDataFromServer();
        this.dialog = true;
      }
    },
    resetFormData() {
      this.formData = {
        command_id: null,
        priority: null,
        cron_expression: null,
        status: null,
        description: null,
      };
    },
    loadDataFromServer() {
      let url = "/cod/billing_schedules/create";
      let data = "";
      if (this.actionType) {
        data = { id: this.$store.getters.getItemForAction.id };
        url = "/cod/billing_schedules/edit";
      }
      this.pageLoader(true);
      ApiService.post(url, data)
        .then(({ data }) => {
          this.serverData = data;
          if (this.actionType) this.formData = data.schedule;
          this.pageLoader(false);
        })
        .catch(() => {
          this.dialog = false;
          this.pageLoader(false);
        });
    },
    handleFormValidation(fieldName) {
      const errors = [];
      if (!this.$v.formData[fieldName].$dirty) return errors;
      if ("required" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].required &&
          errors.push("This field is required");
      }
      return errors;
    },
    submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.pageLoader(true);

      let actionUrl = "store";
      if (this.actionType) actionUrl = "update";
      ApiService.post(`/cod/billing_schedules/${actionUrl}`, this.formData)
        .then(() => {
          if (this.actionType) swalEdited();
          else swalAdded();
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
  },
  computed: {
    // if true, we are editing item, false we are adding
    actionType: function () {
      return !!this.$store.getters.getItemForAction;
    },
    submitButtonText: function () {
      if (this.actionType) return "Update";
      else return "Submit";
    },
    headerText: function () {
      if (this.actionType) return "Edit Item";
      else return "Add New Item";
    },

    command_idErrors: function () {
      return this.handleFormValidation("command_id");
    },
    priorityErrors: function () {
      return this.handleFormValidation("priority");
    },
    cron_expressionErrors: function () {
      return this.handleFormValidation("cron_expression");
    },
  },
};
</script>
